import prizeDesktop1 from "assets/vote/2023superpowers/DESKTOP/prizeDesktop1.png";
import prizeDesktop2 from "assets/vote/2023superpowers/DESKTOP/prizeDesktop2.png";
import prizeDesktop3 from "assets/vote/2023superpowers/DESKTOP/prizeDesktop3.png";
// import prizeMobile1 from "assets/vote/2022uniform/MOBILE/1st_M.png";
// import prizeMobile2 from "assets/vote/2022uniform/MOBILE/2nd_M.png";
// import prizeMobile3 from "assets/vote/2022uniform/MOBILE/third_M.png";

const WinPrize = ({
  winnerPlayers,
  userId,
  candidatesModalHandler,
  setModalData,
  candidate,
  clickModalHandler,
}) => {
  const winPrizeIndex = winnerPlayers
    .map(({ playerId }) => playerId)
    .indexOf(userId);
  return (
    <>
      {winPrizeIndex >= 0 && (
        <>
          <div
            // onClick={() => {
            //   candidatesModalHandler();
            //   setModalData(candidate);
            //   clickModalHandler(candidate.playerId);
            // }}
            className="absolute   md:-top-[22px] md:-left-[34px]  -left-[32px] -top-[21px] w-[143px] h-[78px] md:w-[152px] md:h-[83px]"
          >
            {winPrizeIndex + 1 === 1 && (
              <img
                // src={window.innerWidth > 600 ? prizeDesktop1 : prizeMobile1}
                src={prizeDesktop1}
                alt={winPrizeIndex + 1}
              />
            )}
            {winPrizeIndex + 1 === 2 && (
              <img
                // src={window.innerWidth > 600 ? prizeDesktop2 : prizeMobile2}
                src={prizeDesktop2}
                alt={winPrizeIndex + 1}
              />
            )}
            {winPrizeIndex + 1 === 3 && (
              <img
                // src={window.innerWidth > 600 ? prizeDesktop3 : prizeMobile3}
                src={prizeDesktop3}
                alt={winPrizeIndex + 1}
              />
            )}
          </div>
          {/* <div className="absolute bottom-50px left-10px text-black-1 font-bold text-18px">
        第{winPrizeIndex + 1}名
      </div> */}
          {/* {window.innerWidth > 600 ? (
            <BrowserWinPrize
              winPrizeIndex={winPrizeIndex}
              gameInfo={gameInfo}
              candidatesModalHandler={candidatesModalHandler}
              setModalData={setModalData}
              candidate={candidate}
              clickModalHandler={clickModalHandler}
            />
          ) : (
            <MobileWinPrize winPrizeIndex={winPrizeIndex}
            gameInfo={gameInfo}
            candidatesModalHandler={candidatesModalHandler}
            setModalData={setModalData}
            candidate={candidate}
            clickModalHandler={clickModalHandler} />
          )} */}
        </>
      )}
    </>
  );
};

export default WinPrize;
